module.exports = __webpack_public_path__ + "img/doctor-image.ff7c5623.png";